import { opmStorage, Keys } from "./opmStorage";

/**
 * The web payment the guest left for, kept across the trip to the acquirer's payment page.
 *
 * Paying sends the browser away to the acquirer and back to /payment-return, which loads the
 * app from scratch. The return address names the payment (ws, d, sig) but not the page's
 * session, which the status check needs when the acquirer's callback has not reached the
 * server; so it is kept, with the amounts the return page shows. Like everything OPM stores,
 * it is scoped to the restaurant and table, and it expires: a payment page is short-lived.
 */
const WEB_PAYMENT_TTL_SECONDS = 30 * 60;

export const savePendingWebPayment = (restaurantId, elementId, pending) => {
  if (!restaurantId || !elementId) return;
  opmStorage.setWithTtl(Keys.webPayment(restaurantId, elementId), pending, WEB_PAYMENT_TTL_SECONDS);
};

/** The pending payment, when it is the one the return address names. */
export const readPendingWebPayment = (restaurantId, elementId, uniqueId) => {
  if (!restaurantId || !elementId) return null;
  const pending = opmStorage.getWithTtl(Keys.webPayment(restaurantId, elementId));
  return pending && pending.uniqueId === uniqueId ? pending : null;
};

export const clearPendingWebPayment = (restaurantId, elementId) => {
  if (!restaurantId || !elementId) return;
  opmStorage.remove(Keys.webPayment(restaurantId, elementId));
};
